import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements, ActionMenuOption } from 'ui/actionMenu/types';
import type { SendingDomain } from '../types';

type SendingDomainsTableActionButtonProps = {
  onDelete: (row: SendingDomain) => void;
  onSetTrackingDomain: (row: SendingDomain) => void;
  onVerify: (row: SendingDomain) => void;
  projectHasTrackingDomains: boolean;
  rowData: SendingDomain;
};

export const SendingDomainsTableActionButton = ({
  onDelete,
  onSetTrackingDomain,
  onVerify,
  projectHasTrackingDomains,
  rowData,
}: SendingDomainsTableActionButtonProps) => {
  const verifyAction: ActionMenuOption = {
    as: AllowedActionMenuElements.Button,
    content: `${rowData?.isVerified ? 'Unverify' : 'Verify'} domain`,
    id: 'verify-domain-key-action',
    onClick: () => onVerify(rowData),
  };
  const setTrackingAction: ActionMenuOption = {
    as: AllowedActionMenuElements.Button,
    content: 'Set tracking domain',
    id: 'set-tracking-domain-key-action',
    onClick: () => onSetTrackingDomain(rowData),
  };
  const deleteAction: ActionMenuOption = {
    as: AllowedActionMenuElements.Button,
    content: 'Delete',
    id: 'delete-key-action',
    isDestructive: true,
    onClick: () => onDelete(rowData),
  };

  const options = projectHasTrackingDomains
    ? [verifyAction, setTrackingAction, deleteAction]
    : [verifyAction, deleteAction];

  return <OverflowMenu id="sending-domain-table-action-button" options={options} />;
};
